import "./BMXServiceDetailsBox.scss";
const BMXServiceDetailsBox = (props) => {
    const { title, content } = props;
    return (
        <div className="BMXServiceDetailsBox">
            <div className="header">
                {title}
            </div>

            <div className="content">
                {content}
            </div>
        </div>
    );
};

export default BMXServiceDetailsBox;
